import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import { UPLOAD_IMAGES } from "@api/mutations/upload";
import { UPLOAD_VIDEO, UPLOAD_THREE_D_MODEL } from "@api/mutationsV2/upload";

export const useImageUpload = () => {
  const [uploadImages, { loading: loadingImages }] = useMutation(UPLOAD_IMAGES);

  const uploadImage = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => reject(new Error("file reading was aborted"));
      reader.onerror = () => reject(new Error("file reading has failed"));
      reader.onload = () => {
        uploadImages({
          variables: {
            input: {
              file: reader.result,
              name: file.name,
            },
          },
        })
          .then((data) => {
            const response = data.data.uploadImages;
            if (!response.success) {
              toast.error(`Image ${file.name} was not uploaded`);
              reject(new Error("Upload failed"));
              return;
            }
            resolve(response.urls[0]);
          })
          .catch(reject);
      };
    });
  };

  return { uploadImage, loading: loadingImages };
};

export const useVideoUpload = () => {
  const [uploadVideo, { loading: loadingVideo }] = useMutation(UPLOAD_VIDEO, {
    context: { clientName: "v2" },
  });

  const uploadVideoFile = async (file) => {
    try {
      const data = await uploadVideo({
        variables: {
          title: file.name,
          video: file,
        },
      });
      const response = data.data.uploadVideo;
      if (response.ErrorCode) {
        toast.error(
          `Video ${file.name} was not uploaded. [${response.ErrorCode}]: ${response.ErrorReason}`,
        );
        throw new Error("Upload failed");
      }
      return response.videoUrl;
    } catch (error) {
      throw error;
    }
  };

  return { uploadVideoFile, loading: loadingVideo };
};

export const useThreeDUpload = () => {
  const [uploadThreeDModel, { loading: loadingThreeDModel }] = useMutation(
    UPLOAD_THREE_D_MODEL,
    {
      context: { clientName: "v2" },
    },
  );

  const uploadThreeDFile = async (file) => {
    try {
      const data = await uploadThreeDModel({
        variables: {
          title: file.name,
          model: file,
        },
      });
      const response = data.data.upload3dModel;
      if (response.ErrorCode) {
        toast.error(
          `ThreeD model ${file.name} was not uploaded. [${response.ErrorCode}]: ${response.ErrorReason}`,
        );
        throw new Error("Upload failed");
      }
      return response.modelUrl;
    } catch (error) {
      throw error;
    }
  };

  return { uploadThreeDFile, loading: loadingThreeDModel };
};
